import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../page/about";
// import Logo from "../../asset/logo.png";
import { Link } from "react-router-dom";

import Navbar from "../navbar";
import Footer from "../Footer";

const AboutUs = () => {
  const data = [{ button: "Contact US", path: "/contactus" }];
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">About Us</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={2} md={2}></Grid>
        <Grid
          item
          md={8}
          xs={8}
          sx={{
            textAlign: "center",
            // padding: "160px 0",
            padding: "110px 0",
          }}
        >
          <Typography className="text8">
            <b>
              We are a developing Islamic community in Cape Cod ,Massachusetts
              ,USA. We are trying to make a Mosque at this location with the
              help of our local and external Muslim community. We accept any
              type of donations in the name of Allah. For any further
              information you can contact us by (mail, email, and phone)
            </b>
          </Typography>
          {data.map((user) => (
            <Link to={user.path} style={{ textDecoration: "none" }}>
              <Button
                className="main-btn1"
                sx={{
                  fontWeight: "700",
                  color: "white",
                  border: "1px solid white",
                  width: "20%",
                  borderRadius: "20px",
                  marginTop: "10px",
                }}
              >
                Contact Us
              </Button>
            </Link>
          ))}
        </Grid>
        <Grid item xs={2} md={2}></Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default AboutUs;
